import { ApiService } from './api.service';

class BrandServiceApi extends ApiService {
  getBrands = (params: any) => this.get('/admin/brands', { params });
}
export const BrandService = new BrandServiceApi(process.env.REACT_APP_API_HOST);
